import { ROUTE_INDEX_PERSONS } from '@/config/constants'

export default [
  {
    component: () => import(/* webpackChunkName: "screen-cobrowse" */ '@/modules/Configurator/screens/Cobrowse.vue'),
    meta: {
      index: ROUTE_INDEX_PERSONS,
      secured: true,
    },
    name: 'cobrowse',
    path: '/cobrowse',
  },
]
